
import { Stroke } from './stroke.js';
export class BrushStroke extends Stroke {

    constructor(gl, width, height) {
        super(gl, width, height);
        var self = this;
        self._accumulate = true;
        self._program = 'brushStroke';
    }

}